import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from '@ipc/ipc-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAssetType } from '../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getUserRole } from '../../common/user/redux/selectors/UserDataSelectors';

const mapStateToProps = (state) => ({
  assetType: getAssetType(state),
  userRoles: getUserRole(state),
});

export class TopNavigationMenu extends Component {
  render() {
    const assetType = this.props.assetType.appContext;
    const trayUser = assetType === 'tray';
    const bagUser = assetType === 'bag';
    const palletUser = assetType === 'pallet';
    const ipcUser = this.props.userRoles.find((userRole) => userRole.includes('MANAGER')) !== undefined;

    const { capeHost } = process.env;

    return (
      <div className="header-center-menu">
        <ul>
          <li>
            <div className="icon-container">
              <div className="label">
                <FontAwesomeIcon icon="angle-down" className="icon" />
                <FormattedMessage id="menu.item.stock.management" />
                <div className="icon-container-items">
                  <ul>
                    <li>
                      <Link to="/impc-stock-levels" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.stock.management.transactions" />
                        </div>
                      </Link>
                    </li>
                    <li className={`menu-item ${ipcUser}`}>
                      <Link to="/center-initiated-repatriations" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.stock.management.center.repatriations" />
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/internal-repatriations" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.stock.management.internal.repatriations" />
                        </div>
                      </Link>
                    </li>
                    <li className={`menu-item ${ipcUser && palletUser}`}>
                      <Link to="/daily-route-leading-count-status" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.stock.management.daily.route" />
                        </div>
                      </Link>
                    </li>
                    <li className={`menu-item ${ipcUser && palletUser}`}>
                      <Link to="/edi-rfid-audit" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.stock.management.edi-rfid.audit" />
                        </div>
                      </Link>
                    </li>
                    <li className={`menu-item ${ipcUser}`}>
                      <Link to="/recalculate-tasks" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.stock.management.recalculate.task" />
                        </div>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="icon-container">
              <div className="label">
                <FontAwesomeIcon icon="angle-down" className="icon" />
                <FormattedMessage id="menu.item.transactions.management" />
                <div className="icon-container-items">
                  <ul>
                    <li>
                      <Link to="/transaction-management" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.transactions.management.view" />
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/transaction-history" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.transactions.management.history" />
                        </div>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="icon-container">
              <div className="label">
                <FontAwesomeIcon icon="angle-down" className="icon" />
                <FormattedMessage id="menu.item.reporting" />
                <div className="icon-container-items">
                  <ul>
                    <li>
                      <Link to="/reporting/flux-volume-operator" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.flux-vol.operator" />
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/reporting/flux-volume-oe" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.flux-vol.impc" />
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/reporting/balance-on-hand" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.boh" />
                        </div>
                      </Link>
                    </li>
                    <li className={`menu-item ${ipcUser}`}>
                      <Link to="/reporting/total-pool-breakdown" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.total.pool.reporting" />
                        </div>
                      </Link>
                    </li>
                    <li className={`menu-item ${trayUser}`}>
                      <a href={`${capeHost}/#/en/report-wizard/TRAY_USAGE_940`} target="_blank" rel="noreferrer" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.tray.usage" />
                          <span className="badge badge-danger" style={{ marginLeft: '3px' }}>CAPE</span>
                        </div>
                      </a>
                    </li>
                    <li className={`menu-item ${trayUser}`}>
                      <a href={`${capeHost}/#/en/report-wizard/MIXED_TRAY_USAGE_942`} target="_blank" rel="noreferrer" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.tray.mixedUsage" />
                          <span className="badge badge-danger" style={{ marginLeft: '3px' }}>CAPE</span>
                        </div>
                      </a>
                    </li>
                    <li className={`menu-item ${trayUser}`}>
                      <a href={`${capeHost}/#/en/report-wizard/COMPARATIVE_TRAY_USAGE_941`} target="_blank" rel="noreferrer" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.tray.comparativeUsage" />
                          <span className="badge badge-danger" style={{ marginLeft: '3px' }}>CAPE</span>
                        </div>
                      </a>
                    </li>
                    <li className={`menu-item ${bagUser}`}>
                      <a href={`${capeHost}/#/en/report-wizard/BAG_USAGE_950`} target="_blank" rel="noreferrer" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.bag.usage" />
                          <span className="badge badge-danger" style={{ marginLeft: '3px' }}>CAPE</span>
                        </div>
                      </a>
                    </li>
                    <li className={`menu-item ${bagUser}`}>
                      <a href={`${capeHost}/#/en/report-wizard/COMPARATIVE_BAG_USAGE_951`} target="_blank" rel="noreferrer" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.bag.comparativeUsage" />
                          <span className="badge badge-danger" style={{ marginLeft: '3px' }}>CAPE</span>
                        </div>
                      </a>
                    </li>
                    <li className={`menu-item ${palletUser}`}>
                      <a href={`${capeHost}/#/en/report-wizard/PALLET_BOX_USAGE_960`} target="_blank" rel="noreferrer" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.pallet.usage" />
                          <span className="badge badge-danger" style={{ marginLeft: '3px' }}>CAPE</span>
                        </div>
                      </a>
                    </li>
                    <li className={`menu-item ${palletUser}`}>
                      <a href={`${capeHost}/#/en/report-wizard/COMPARATIVE_PALLET_BOX_USAGE_961`} target="_blank" rel="noreferrer" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.pallet.comparativeUsage" />
                          <span className="badge badge-danger" style={{ marginLeft: '3px' }}>CAPE</span>
                        </div>
                      </a>
                    </li>
                    <li className={`menu-item ${trayUser}`}>
                      <a href={`${capeHost}/#/en/report-wizard/IPC_TRAY_IL_PREDES_RESDES_ANALYSIS`} target="_blank" rel="noreferrer" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.predes.resdes.diff" />
                          <span className="badge badge-danger" style={{ marginLeft: '3px' }}>CAPE</span>
                        </div>
                      </a>
                    </li>
                    <li className={`menu-item ${bagUser}`}>
                      <a href={`${capeHost}/#/en/report-wizard/IPC_BAG_IS_PREDES_RESDES_ANALYSIS`} target="_blank" rel="noreferrer" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.predes.resdes.diff" />
                          <span className="badge badge-danger" style={{ marginLeft: '3px' }}>CAPE</span>
                        </div>
                      </a>
                    </li>
                    <li className={`menu-item ${palletUser}`}>
                      <a href={`${capeHost}/#/en/report-wizard/IPC_PALLET_BOX_IB_PREDES_RESDES_ANALYSIS`} target="_blank" rel="noreferrer" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.predes.resdes.diff" />
                          <span className="badge badge-danger" style={{ marginLeft: '3px' }}>CAPE</span>
                        </div>
                      </a>
                    </li>
                    <li className={`menu-item ${ipcUser}`}>
                      <a href={`${capeHost}/#/en/report-wizard/DESPATCH_PARTICULARS_OVERVIEW`} target="_blank" rel="noreferrer" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.volume.preadvised" />
                          <span className="badge badge-danger" style={{ marginLeft: '3px' }}>CAPE</span>
                        </div>
                      </a>
                    </li>
                    <li className={`menu-item ${ipcUser && palletUser}`}>
                      <Link to="/reporting/rfid-movement-count" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.rfid.movements.counts" />
                        </div>
                      </Link>
                    </li>
                    <li className={`menu-item ${ipcUser && palletUser}`}>
                      <Link to="/reporting/rfids-on-route" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.rfids.on.route" />
                        </div>
                      </Link>
                    </li>
                    <li className={`menu-item ${ipcUser && palletUser}`}>
                      <Link to="/reporting/daily-route-leading-count" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.reporting.daily.route.summary" />
                        </div>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div className="icon-container">
              <div className="label">
                <FontAwesomeIcon icon="angle-down" className="icon" />
                <FormattedMessage id="menu.item.settings" />
                <div className="icon-container-items">
                  <ul>
                    <li>
                      <Link to="/route-management" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.settings.route.management" />
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/impc-details" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.settings.impc.management" />
                        </div>
                      </Link>
                    </li>
                    <li>
                      <Link to="/user-list" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.settings.user.management" />
                        </div>
                      </Link>
                    </li>
                    <li className={`menu-item ${trayUser && ipcUser}`}>
                      <Link to="/member-pool-storage" className="choice">
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.settings.member.pool.storage" />
                        </div>
                      </Link>
                    </li>
                    <Link to="/rfid-management" className="choice">
                      <li className={`menu-item ${palletUser}`}>
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.settings.rfid" />
                        </div>
                      </li>
                    </Link>
                    <Link to="/pool-management" className="choice">
                      <li className={`menu-item ${ipcUser}`}>
                        <div className="sub-label">
                          <FormattedMessage id="menu.item.settings.pool.membership.management" />
                        </div>
                      </li>
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

TopNavigationMenu.propTypes = {
  assetType: PropTypes.objectOf(PropTypes.shape),
  userRoles: PropTypes.arrayOf(PropTypes.string),
};

export default connect(mapStateToProps)(TopNavigationMenu);
